export default "__VITE_ASSET__CbljfevO__"